/** Guia de primeiros passos: o que falta configurar para o escritório começar a usar — calculado do que já existe no banco. */
import { z } from 'zod';

export const PassoInicial = z.object({
  id: z.string(), titulo: z.string(), porque: z.string(), feito: z.boolean(),
  /** quanto já tem (ex.: "12 clientes") */
  situacao: z.string().nullable(),
  /** rota da tela onde se faz */
  para: z.string(), rotuloBotao: z.string(),
  /** passo que não trava o começo (equipe de uma pessoa só, integrações) */
  opcional: z.boolean(),
});
export type PassoInicial = z.infer<typeof PassoInicial>;
export const PrimeirosPassos = z.object({ passos: z.array(PassoInicial), feitos: z.number().int(), total: z.number().int(), oculto: z.boolean(), completo: z.boolean() });
export type PrimeirosPassos = z.infer<typeof PrimeirosPassos>;
export const PrimeirosPassosBody = z.object({ oculto: z.boolean() });
